export default __webpack_public_path__ + "static/media/qanon_title.7947459c.jpg";